// gerado por work/gerar_pdp.py - nao editar a mao
(function () {
  function ligar() {
    var alvo = document.getElementById('ionix-sg-overlay') || document.querySelector('.ix-pp');
    if (!alvo) return;
    var raiz = alvo.closest('.product-info') || document.body;
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';
    /* guia */
    (function() {
      var overlay = document.getElementById('ionix-sg-overlay');
      var openBtn = document.getElementById('ionix-sg-open');
      var closeBtn = document.getElementById('ionix-sg-close');
      if (!overlay || !openBtn || !closeBtn) return;

      function openModal() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function closeModal() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
      openBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

      var tabs = overlay.querySelectorAll('.ionix-sg-tab');
      var panels = overlay.querySelectorAll('.ionix-sg-panel');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function(t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function(p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === target); });
        });
      });

      // SIZES for SHORTS — body targets = supplier flat × 1.20 (20% stretch)
      var SIZES = [
        { label: 'S',   waistIn: 27.5, hipIn: 34.0, lengthCm: 47, us: '0–2',   uk: '4–6',   eu: '32–34' },
        { label: 'M',   waistIn: 29.3, hipIn: 35.9, lengthCm: 48, us: '4',     uk: '8',     eu: '36'    },
        { label: 'L',   waistIn: 31.2, hipIn: 37.8, lengthCm: 49, us: '6–8',   uk: '10–12', eu: '38–40' },
        { label: 'XL',  waistIn: 33.1, hipIn: 39.7, lengthCm: 50, us: '10',    uk: '14',    eu: '42'    },
        { label: '2XL', waistIn: 35.0, hipIn: 41.6, lengthCm: 51, us: '12',    uk: '16',    eu: '44'    },
        { label: '3XL', waistIn: 36.9, hipIn: 43.5, lengthCm: 52, us: '14',    uk: '18',    eu: '46'    }
      ];

      var state = { unit: 'cm', waist: null, hip: null, fit: 'balanced' };

      var inputWaist  = document.getElementById('ionix-ff-waist');
      var inputHip    = document.getElementById('ionix-ff-hip');
      var waistUnit   = document.getElementById('ionix-ff-waist-unit');
      var hipUnit     = document.getElementById('ionix-ff-hip-unit');
      var errorBox    = document.getElementById('ionix-ff-error');
      var progressBar = document.getElementById('ionix-ff-bar');
      var stepLabel   = document.getElementById('ionix-ff-step-label');
      var unitButtons = overlay.querySelectorAll('.ionix-ff-unit');
      var steps       = overlay.querySelectorAll('.ionix-ff-step');

      function setUnit(unit) {
        state.unit = unit;
        unitButtons.forEach(function(b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === unit); });
        var label = unit === 'cm' ? 'cm' : 'in';
        waistUnit.textContent = label; hipUnit.textContent = label;
        inputWaist.placeholder = unit === 'cm' ? "e.g." + ' 76' : "e.g." + ' 30';
        inputHip.placeholder   = unit === 'cm' ? "e.g." + ' 97' : "e.g." + ' 38';
      }

      unitButtons.forEach(function(b) { b.addEventListener('click', function() { setUnit(b.getAttribute('data-unit')); }); });

      function setStep(n) {
        steps.forEach(function(s) { s.classList.toggle('is-active', parseInt(s.getAttribute('data-step'), 10) === n); });
        progressBar.style.width = (n * 33.33) + '%';
        stepLabel.textContent = "Step __N__ of 3".replace('__N__', n);
      }

      function readMeasurements() {
        var w = parseFloat(inputWaist.value);
        var h = parseFloat(inputHip.value);
        if (isNaN(w) || w <= 0) return { ok: false, msg: "Please enter your waist measurement." };
        if (isNaN(h) || h <= 0) return { ok: false, msg: "Please enter your hip measurement." };
        var wIn = state.unit === 'in' ? w : w / 2.54;
        var hIn = state.unit === 'in' ? h : h / 2.54;
        if (wIn < 20 || wIn > 60) return { ok: false, msg: "Your waist measurement seems off — please double-check." };
        if (hIn < 28 || hIn > 64) return { ok: false, msg: "Your hip measurement seems off — please double-check." };
        state.waist = wIn; state.hip = hIn;
        return { ok: true };
      }

      function recommend() {
        var waistIdx = -1, hipIdx = -1;
        for (var i = 0; i < SIZES.length; i++) {
          if (waistIdx === -1 && state.waist <= SIZES[i].waistIn) waistIdx = i;
          if (hipIdx === -1   && state.hip   <= SIZES[i].hipIn)   hipIdx = i;
        }
        var outOfRange = false;
        if (waistIdx === -1) { waistIdx = SIZES.length - 1; outOfRange = true; }
        if (hipIdx === -1)   { hipIdx   = SIZES.length - 1; outOfRange = true; }

        var baseIdx = Math.max(waistIdx, hipIdx);
        var finalIdx = baseIdx;
        if (state.fit === 'firm' && baseIdx > 0) {
          var s = SIZES[baseIdx];
          if ((s.hipIn - state.hip) > 1) finalIdx = baseIdx - 1;
        }

        var morphologyMismatch = Math.abs(waistIdx - hipIdx) >= 2;

        return {
          size: SIZES[finalIdx],
          baseSize: SIZES[baseIdx],
          didAdjust: finalIdx !== baseIdx,
          outOfRange: outOfRange,
          morphologyMismatch: morphologyMismatch,
          waistIdx: waistIdx,
          hipIdx: hipIdx
        };
      }

      function renderResult() {
        var r = recommend();
        var s = r.size;
        var lengthIn = (s.lengthCm / 2.54).toFixed(1);

        var html = '';
        html += '<p class="ionix-ff-result__title">' + "Your Recommended Size" + '</p>';
        html += '<p class="ionix-ff-result__size">' + s.label + '</p>';
        html += '<p class="ionix-ff-result__intl">US ' + s.us + ' &middot; UK ' + s.uk + ' &middot; EU ' + s.eu + '</p>';

        html += '<div class="ionix-ff-result__rows">';
        html += '  <div class="ionix-ff-result__row"><span class="ionix-ff-result__row-label">' + "Waist fits up to" + '</span><span class="ionix-ff-result__row-value">' + s.waistIn + '" (' + Math.round(s.waistIn * 2.54) + ' cm)</span></div>';
        html += '  <div class="ionix-ff-result__row"><span class="ionix-ff-result__row-label">' + "Hip fits up to" + '</span><span class="ionix-ff-result__row-value">' + s.hipIn + '" (' + Math.round(s.hipIn * 2.54) + ' cm)</span></div>';
        html += '  <div class="ionix-ff-result__row"><span class="ionix-ff-result__row-label">' + "Inseam length" + '</span><span class="ionix-ff-result__row-value">' + lengthIn + '" (' + s.lengthCm + ' cm)</span></div>';
        html += '</div>';

        if (r.outOfRange) {
          html += '<div class="ionix-ff-result__note ionix-ff-result__note--warn"><strong>' + "You may be outside our size range." + '</strong>' + "Our largest shorts size (3XL) fits up to 37\" waist and 43.5\" hip. Please contact our team before ordering." + '</div>';
        } else if (r.morphologyMismatch) {
          var bigger = r.hipIdx > r.waistIdx ? 'hips' : 'waist';
          var smaller = bigger === 'hips' ? 'waist' : 'hips';
          var W = {hips: "hips", waist: "waist"};
          html += '<div class="ionix-ff-result__note"><strong>' + "Your body shape: __A__ larger than __B__.".replace('__A__', W[bigger]).replace('__B__', W[smaller]) + '</strong>' + "We sized you based on your __A__ (the tighter constraint). The __B__ may feel a bit looser — normal for this body shape.".replace('__A__', W[bigger]).replace('__B__', W[smaller]) + '</div>';
        } else if (r.didAdjust) {
          html += '<div class="ionix-ff-result__note"><strong>' + "Compression preference applied." + '</strong>' + "One size down (__A__ instead of __B__) for a stronger sculpting effect.".replace('__A__', r.size.label).replace('__B__', r.baseSize.label) + '</div>';
        } else {
          html += '<div class="ionix-ff-result__note"><strong>' + "Perfect match." + '</strong>' + "__A__ fits both your waist and hips comfortably with visible sculpting effect.".replace('__A__', s.label) + '</div>';
        }

        document.getElementById('ionix-ff-result').innerHTML = html;
      }

      document.getElementById('ionix-ff-to-step2').addEventListener('click', function() {
        var m = readMeasurements();
        if (!m.ok) { errorBox.textContent = m.msg; return; }
        errorBox.textContent = ''; setStep(2);
      });

      document.getElementById('ionix-ff-to-result').addEventListener('click', function() {
        var checked = overlay.querySelector('input[name="ff-fit"]:checked');
        state.fit = checked ? checked.value : 'balanced';
        renderResult(); setStep(3);
      });

      overlay.querySelectorAll('.ionix-ff-back').forEach(function(b) {
        b.addEventListener('click', function() { setStep(parseInt(b.getAttribute('data-go'), 10)); });
      });

      document.getElementById('ionix-ff-restart').addEventListener('click', function() {
        inputWaist.value = ''; inputHip.value = '';
        errorBox.textContent = ''; state.waist = state.hip = null; state.fit = 'balanced';
        var defaultFit = overlay.querySelector('input[name="ff-fit"][value="balanced"]');
        if (defaultFit) defaultFit.checked = true;
        setStep(1);
      });

      setStep(1);
    })();

    /* confianca */
    (function(){var f=document.getElementById('ix-flag'),c=document.getElementById('ix-country'),s=document.getElementById('ix-sold');/* country + flag rendered server-side from Shopify Markets (localization.country) */var n=Math.floor(Math.random()*6)+12;if(s)s.textContent="__N__ sold in the last hour".replace('__N__', n);(function loop(){setTimeout(function(){var r=Math.random();if(r<.35)n+=1;else if(r<.5)n+=2;if(n>28)n=11+Math.floor(Math.random()*4);if(s){s.style.opacity='0';setTimeout(function(){s.textContent="__N__ sold in the last hour".replace('__N__', n);s.style.opacity='1'},200)}loop()},10000+Math.floor(Math.random()*15000))})()});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
  var pendente = null;
  new MutationObserver(function () {
    clearTimeout(pendente);
    pendente = setTimeout(ligar, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
